var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.27075 23.375V32.7292C6.27075 42.0833 10.0208 45.8333 19.3749 45.8333H30.6041C39.9583 45.8333 43.7083 42.0833 43.7083 32.7292V23.375",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 25C28.8125 25 31.625 21.8958 31.25 18.0833L29.875 4.16663H20.1458L18.75 18.0833C18.375 21.8958 21.1875 25 25 25Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.1458 25C42.3541 25 45.4375 21.5833 45.0208 17.3958L44.4375 11.6666C43.6875 6.24996 41.6041 4.16663 36.1458 4.16663H29.7916L31.25 18.7708C31.6041 22.2083 34.7083 25 38.1458 25Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.75 25C15.1875 25 18.2917 22.2083 18.625 18.7708L19.0833 14.1666L20.0834 4.16663H13.7292C8.27085 4.16663 6.1875 6.24996 5.4375 11.6666L4.875 17.3958C4.45833 21.5833 7.54167 25 11.75 25Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25 35.4166C21.5208 35.4166 19.7916 37.1458 19.7916 40.625V45.8333H30.2083V40.625C30.2083 37.1458 28.4791 35.4166 25 35.4166Z",
    stroke: "#121212",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSvgrepoCom1);
export default __webpack_public_path__ + "static/media/shop-svgrepo-com 1.b2495909b3db1ee4de88ef68ab531a4a.svg";
export { ForwardRef as ReactComponent };